import React, {useState} from 'react';
import {Text, TouchableOpacity} from 'react-native';
import Fontisto from 'react-native-vector-icons/Fontisto';
import {Colors} from '../../../../../constants/Colors';
import {styles} from './styles';

interface ISwitch {
  title: string;
  initialState?: boolean;
  onPress: () => void;
}

const Switch = ({title, initialState, onPress}: ISwitch) => {
  const [toggle, setToggle] = useState<boolean | undefined>(initialState);

  const toggleSwitch = () => {
    setToggle(!toggle);
  };

  return (
    <TouchableOpacity onPress={onPress} style={styles.container}>
      {initialState ? (
        <Fontisto
          name="toggle-on"
          size={36}
          color={Colors.RedPallete.red}
          style={styles.icon}
        />
      ) : (
        <Fontisto
          name="toggle-off"
          size={36}
          color={Colors.GrayPallete.lightgrayTwo}
          style={styles.icon}
        />
      )}
      <Text style={styles.title}>{title}</Text>
    </TouchableOpacity>
  );
};

export default Switch;
